import { render, staticRenderFns } from "./schoolAdministrator.vue?vue&type=template&id=3c1fc47e&scoped=true&"
import script from "./schoolAdministrator.vue?vue&type=script&lang=js&"
export * from "./schoolAdministrator.vue?vue&type=script&lang=js&"
import style0 from "./schoolAdministrator.vue?vue&type=style&index=0&id=3c1fc47e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1fc47e",
  null
  
)

export default component.exports